<!-- Единая компактная кнопка удаления строки или выбранной сущности -->
<template>
  <button
    type="button"
    class="base-delete-icon-button"
    :title="title"
    :aria-label="title"
    @click="$emit('click', $event)"
  >
    <AppIcon :name="icon" :size="iconSize" />
  </button>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseDeleteIconButton",

  components: {
    AppIcon,
  },

  props: {
    title: {
      type: String,
      default: "Удалить",
    },
    iconSize: {
      type: [Number, String],
      default: 18,
    },
    icon: {
      type: String,
      default: "trash",
    },
  },

  emits: ["click"],
};
</script>

<style scoped>
.base-delete-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 32px;
  min-width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #fee2e2;
  border-radius: 6px;
  background: #fff7f7;
  color: var(--color-danger);
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s, color 0.2s;
}

.base-delete-icon-button:hover {
  border-color: var(--color-danger);
  background: #fff1f1;
}

.base-delete-icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
</style>
